// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"331":"36e3586a","813":"323b3897"}[chunkId] + ".chunk.css";
};